import { useMutation } from "@tanstack/react-query";
import { useInvalidate, useNotification, useTranslate } from "@refinedev/core";
import { useNavigate } from "react-router";

import { ApiError } from "@shared/types";
import { Partner } from "@modules/partners/types";
import { PartnerFormValues } from "@modules/partners/validations";

import { createPartnerService } from "./service";
import { UseCreatePartnerMutationOptions } from "./types";

export function useCreatePartnerMutation(
  options?: UseCreatePartnerMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();
  const invalidate = useInvalidate();

  return useMutation<Partner, ApiError, PartnerFormValues>({
    mutationFn: createPartnerService,
    onSuccess: (partner) => {
      // tabela usa useList do refine; a key dele não começa com listPartnersQueryKey
      invalidate({ resource: "v1/partner_admin", invalidates: ["list"] });
      open?.({ type: "success", message: translate("v1/partner_admin.success.create") });
      navigate(`/partners/edit/${partner.id}`);
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
    ...options,
  });
}
